import { useEffect, useState } from "react";
import axiosInstant from "../../api";
import { proposalWizardConfigEndpoint } from "../../api/endpoints";
import { ProposalWizardConfig } from "./types";

// Fetch-once hook for the wizard's objectives/channels/categories config.
// The default endpoint is public — no auth required. The RMN portal passes
// /rmn/proposals/config (same shape, filtered to the network's content
// types + an extra `placements` array).
export const useProposalWizardConfig = (endpoint: string = proposalWizardConfigEndpoint) => {
    const [config, setConfig] = useState<ProposalWizardConfig | null>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        let cancelled = false;
        setLoading(true);
        axiosInstant
            .get<ProposalWizardConfig>(endpoint)
            .then(({ data }) => {
                if (cancelled) return;
                setConfig(data);
                setError(null);
            })
            .catch(() => {
                if (cancelled) return;
                setError("We couldn't load the builder. Please try again.");
            })
            .finally(() => {
                if (cancelled) return;
                setLoading(false);
            });
        return () => {
            cancelled = true;
        };
    }, [endpoint]);

    return { config, loading, error };
};
